module.exports = __webpack_public_path__ + "static/media/lvjian-jinyingshijie.9657826e.jpg";